import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card, CardBody, CardHeader,
  Container, Row, Col, Button, FormGroup, Label, Input,
} from "reactstrap";
import { alertsRepo } from "data/repositories/alertsRepo";
import { provincesRepo } from "data/repositories/provincesRepo";

import { themeLabel } from "labels/tr";

const THEMES = ["Nature", "History", "Culture", "Food", "Adventure", "Sea"];

export default function CreateAlert() {
  const navigate = useNavigate();
  const [provinces, setProvinces] = useState([]);
  const [form, setForm] = useState({ provinceId: "", theme: "", dateFrom: "", dateTo: "" });

  useEffect(() => {
    setProvinces(provincesRepo.list());
  }, []);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    alertsRepo.create(form);
    navigate("/admin/alerts");
  };

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Yeni Bildirim</h2>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="shadow">
              <CardHeader><h3 className="mb-0">Bildirim Ayarları</h3></CardHeader>
              <CardBody>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Şehir (opsiyonel)</Label>
                        <Input type="select" value={form.provinceId} onChange={set("provinceId")}>
                          <option value="">Tümü</option>
                          {provinces.map((p) => (
                            <option key={p.id} value={p.id}>{p.name}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Tema (opsiyonel)</Label>
                        <Input type="select" value={form.theme} onChange={set("theme")}>
                          <option value="">Tümü</option>
                          {THEMES.map((t) => (
                            <option key={t} value={t}>{themeLabel(t)}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Başlangıç tarihi</Label>
                        <Input value={form.dateFrom} onChange={set("dateFrom")} placeholder="GG-AA-YYYY" required />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label>Bitiş tarihi</Label>
                    <Input value={form.dateTo} onChange={set("dateTo")} placeholder="GG-AA-YYYY" required />
                  </FormGroup>
                  <Button color="primary" type="submit">Bildirim Oluştur</Button>
                  <Button color="secondary" className="ml-2" onClick={() => navigate(-1)}>Vazgeç</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
